import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";

const ImageUploadInput = ({
  image,
  onImageChange,
  onRemoveImage,
  isLoading = false,
  inputRef,
  icon = {
    outer: "fas fa-circle",
    inner: "fas fa-store",
  },
  labelClass = "",
  fullPreview = false,
  height = "125px",
}) => {
  return (
    <>
      <label
        htmlFor="upload-button"
        className={`form-file-input position-relative d-flex align-items-center justify-content-center w-100 rounded cursor-pointer overflow-hidden ${labelClass}`}
        style={{ height }}
      >
        {image ? (
          <>
            <img
              src={
                typeof image === "string" ? image : URL.createObjectURL(image)
              }
              alt="label-img"
              className={fullPreview ? "w-100 h-100" : "form-input-img"}
              style={{ objectFit: "contain" }}
            />
            <Button
              size="sm"
              color="danger"
              className="position-absolute top-2 right-2"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onRemoveImage();
              }}
              disabled={isLoading}
            >
              Remove
            </Button>
          </>
        ) : (
          <span className="fa-stack fa-2x">
            <i className={icon.outer + " fa-stack-2x"} />
            <i className={icon.inner + " fa-stack-1x fa-inverse"} />
          </span>
        )}
      </label>
      <input
        id="upload-button"
        type="file"
        ref={inputRef}
        className="d-none"
        onChange={onImageChange}
      />
    </>
  );
};

ImageUploadInput.propTypes = {
  imageData: PropTypes.shape({
    labelURL: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
  onImageChange: PropTypes.func.isRequired,
  onRemoveImage: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  icon: PropTypes.shape({
    outer: PropTypes.string,
    inner: PropTypes.string,
  }),
  labelClass: PropTypes.string,
};

export default ImageUploadInput;
